import './App.scss'
import './components/styles/typography.scss'
import './components/styles/buttons.scss'
import './components/styles/Popup.scss'
import './components/styles/Borders.scss'
import './components/styles/Shadows.scss'
import './components/styles/Blocks.scss'

import './components/styles/vars.scss'
import './components/styles/mixins.scss'

import { useState } from 'react'

import { BrowserRouter, Route, Routes } from 'react-router-dom'
import PopupContext from './context/popupContext'

import Home from './components/Home'
import MainLayout from './layouts/MainLayout'
import AboutUs from './components/AboutUs'
import Career from './components/Career'
import Product from './components/Product'
import OurProducts from './components/OurProducts'
import Clients from './components/Clients'
import ClientItem from './components/ClientItem'
import PrivacyPolicy from './components/PrivacyPolicy'
import ScrollToTopOnPageChange from './components/ScrollToTopOnPageChange'
import BlogList from './components/BlogList'
import BlogItem from './components/BlogItem'
import {OurProductsSecond} from './components/OurProducts'
import Price from './components/Price'

function App() {
    const [currentPopup, setCurrentPopup] = useState({ content: '', isActive: false })

    return (
        <BrowserRouter>
            <ScrollToTopOnPageChange />
            <PopupContext.Provider value={{ currentPopup, setCurrentPopup }}>
                <div className="App">
                    <Routes>
                        <Route path="/" element={<MainLayout />}>
                            <Route index={true} element={<Home />} />

                            <Route path="/about-us" element={<AboutUs />}></Route>
                            <Route path="/career" element={<Career />}></Route>

                            <Route path="/product/:idOfProduct" element={<Product />}></Route>
                            <Route path="/product/" element={<OurProductsSecond />}></Route>

                            <Route path="/price" element={<Price />}></Route>

                            <Route path="/clients" element={<Clients />}></Route>
                            <Route path="/clients/:clientName" element={<ClientItem />}></Route>

                            <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>

                            <Route path="/blog" element={<BlogList />} />
                            <Route path="/blog/:blogItemId" element={<BlogItem />} />
                        </Route>
                    </Routes>
                </div>
            </PopupContext.Provider>
        </BrowserRouter>
    )
}

export default App
